import * as loadjs from 'loadjs';
import * as $ from 'jquery';
export default function (baseUrl: string, target: HTMLElement) {
    loadjs([
        baseUrl + '/bootstrap-3-typeahead/bootstrap3-typeahead.min.js',
    ], {
        success: function () {
            if (target.tagName != "INPUT") {
                throw new Error("only INPUT is allowed for data-gs-typeahead");
            }
            const dataName = target.dataset['gsData'];
            if (dataName) {
                let data = window[dataName];
                if (!data) {
                    throw new Error("can not find data in window " + dataName);
                }
                (<any>$(target)).typeahead({ source: data });
                return;
            }
            const jsonUrl = target.dataset['gsJsonUrl']
            if (jsonUrl) {
                $.get(jsonUrl, function (data) {
                    (<any>$(target)).typeahead({ source: data });
                }, 'json').fail(function () {
                    const jsonBackupUrl = target.dataset['gsJsonBackupUrl'];
                    if (jsonBackupUrl) {
                        $.get(jsonBackupUrl, function (data) {
                            (<any>$(target)).typeahead({ source: data });
                        }, 'json')
                    }
                })
                return;
            }
            throw new Error("either data-gs-data or data-gs-json-url is required for data-gs-typeahead");
        }
    });
}
